import React from 'react';
import Style from './liveMemAvator.less';
import './liveMemAvator.less';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import { getStyle } from '../utils/util';
import PropTypes from 'prop-types';

const ANONYMOUS = '-1';
export default class MemberAvator extends React.Component {

    static propTypes = {
        onShowMenu: PropTypes.func,
        liveDelegate: PropTypes.any,
    }

    constructor(props, context) {
        super(props, context);
        
        this.itemWidth = 0;
        this.liveManager = this.props.liveDelegate;
        let checkList = [];
        
        if (this.liveManager) {
            let m = this.liveManager.memberList;
            m.forEach(member => {
                let stamp = true;
                checkList.forEach(elem => {
                    if (elem && elem.uid && elem.uid === member.uid) stamp = false;
                });
                stamp && checkList.push(member);
            });
            if (checkList && checkList.length > 3) {
                checkList = checkList.slice(0, 3);
            }
        }

        this.state = {
            maxCount: 5,
            userList: checkList,
            showMoreTable: false,
        };
    }

    // eslint-disable-next-line react/no-deprecated
    componentWillMount() {
        document.body.addEventListener('click', e => {
            if (this.state.showMoreTable) {
                this.setState({
                    showMoreTable: false,
                });
                e.stopPropagation();
                return;
            }
        });
    }

    userChange(userList) {
        let list = userList;
        if (userList && userList.length > 3) {
            list = userList.slice(0, 3);
        }
        this.setState({
            userList: list,
        });
    }

    fixWidth = (offsetWidth) => {
        if (offsetWidth < 0) {  // 空间不够，让出空间
            if (this.state.maxCount > 1) {
                let hideWidth = this.getHideWidth();
                this.setState({  // 让列表剩下一个
                    maxCount: 1,
                    showMoreTable: false,
                });
                return hideWidth + offsetWidth;
            }
        } else { // 有空间，判断是否能显示所有hide的item
            if (this.state.maxCount === 1) { // 当前显示一个
                let hideWidth = this.getHideWidth();
                if (offsetWidth >= hideWidth) {
                    this.setState({
                        maxCount: 5,
                        showMoreTable: false,
                    });
                    return offsetWidth - hideWidth;
                }
            }
        }
        return offsetWidth;
    }

    // 获取隐藏的item的总宽度
    getHideWidth = () => {
        if (this.state.userList.length > 1) {
            let hideCount = this.state.userList.length - 1; //留一个
            hideCount = hideCount > 6 ? 6 : hideCount;
            if (!this.itemWidth || this.itemWidth === 0) {
                let userDom = document.getElementById(this.state.userList[0].uid);
                let itemWidth = userDom.offsetWidth;
                let marginRight = getStyle(userDom, 'marginRight');
                this.itemWidth = (itemWidth + marginRight);
            }
            let hideWidth = this.itemWidth * hideCount;
            return hideWidth;
        }
        return 0;
    }

    handleMoreClick = (e) => {
        e.stopPropagation();
        this.props.onShowMenu && this.props.onShowMenu();
    }

    hasMoreUser = () => {
        // return ((this.state.userList.length - this.state.maxCount) > 0);
        return true;
    }

    renderUserLine = () => {
        let userLineElement = [];
        if (this.state.userList.length) {
            for (let i = 0; i < this.state.userList.length; i++) {
                let item = this.state.userList[i];
                if (i < this.state.maxCount) {
                    userLineElement.push(
                        <div className={'user-face-container ' + Style['user-face-container']} key={item.uid} id={item.uid}>
                            <Tooltip placement="bottom" title={item.name} overlayStyle={{ whiteSpace: 'normal', maxWidth: '300px'}}>
                                {
                                    item.uid === ANONYMOUS ?
                                        <div className={'audience-liveMem ' + Style['audience-liveMem']} /> :
                                        <img className={'user-face ' + Style['user-face']} src={item.userPic} />
                                }
                            </Tooltip>
                        </div>
                    );
                }
            }
        } else {
            userLineElement.push(
                <div className={'user-face-container ' + Style['user-face-container']} key='temp' id='temp'>
                    <Tooltip placement="bottom" title={'访客'} overlayStyle={{ whiteSpace: 'normal', maxWidth: '300px'}}>
                        <div className={'audience-liveMem ' + Style['audience-liveMem']} /> 
                    </Tooltip>
                </div>
            );
        }
        return userLineElement;
    }

    handleCloseMoreUserTable = () => {

    }

    renderMoreUserTable = () => {
        let moreTable = [];
        for (let i = this.state.maxCount; i < this.state.userList.length; i++) {
            let item = this.state.userList[i];
            moreTable.push(
                <li id={'user' + item.uid + '_Row'} key={'user' + item.uid + '_Row'} >
                    <span className={'user-image ' + Style['user-image']}>
                        <img src={item.userPic} />
                    </span>
                    <span className={'user-name ' + Style['user-name']}>{item.name}</span>
                </li>
            );
        }
        return (
            <div className={'more-table-bg ' + Style['more-table-bg']} onClick={this.handleCloseMoreUserTable}>
                <div className={'more-table-title-wrapper ' + Style['more-table-title-wrapper']}>
                    <span>{this.state.userList.length}人正在查看</span>
                </div>
                {<ul className={'more-table ' + Style['more-table']}>
                    {moreTable}
                </ul>}
            </div>);
    }

    render() {
        return (
            <div className={'users-line-wrapper ' + Style['users-line-wrapper']} id="user-line">
                <div className={'users-line ' + Style['users-line']}>
                    {this.renderUserLine()}
                </div>
                {
                    // 是否显示‘更多’按钮
                    this.hasMoreUser() ?
                        (<div id="present-live-member-more" className={'more-wrapper ' + Style['more-wrapper']} onClick={this.handleMoreClick.bind(this)}>
                            <div className={'more ' + Style['more']}></div>
                        </div>) : null
                }
                {
                    (this.state.showMoreTable && this.hasMoreUser()) ?
                        (<div className={'more-table-wrapper ' + Style['more-table-wrapper']} id = {'more-table-wrapper'}>
                            {this.renderMoreUserTable()}
                        </div>) : null
                }
            </div>
        )
    }
}
